import { DestroyRef, inject, Injectable } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class RouteTrackingService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;
  private lastAttemptedUrl: string | null = null;
  private readonly destroyRef = inject(DestroyRef);
  private router = inject(Router);

  public init() {
    // Отслеживаем завершенные навигации
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects || event.url;
      });

    // Отслеживаем попытки навигации для сохранения returnUrl
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((event: NavigationStart) => {
        // Не сохраняем URL если это редирект на /no-permission
        if (!event.url.includes('/no-permission')) {
          this.lastAttemptedUrl = event.url;
        }
      });
  }

  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }

  public getCurrentUrl(): string | null {
    return this.currentUrl;
  }

  /**
   * Получить последний URL, на который пытался попасть пользователь
   */
  public getLastAttemptedUrl(): string | null {
    return this.lastAttemptedUrl;
  }

  /**
   * Очистить сохраненный returnUrl
   */
  public clearLastAttemptedUrl(): void {
    this.lastAttemptedUrl = null;
  }
}
